import { useContext } from 'react';

import { CoreContext } from './context';

export const useCore = () => {
  const context = useContext(CoreContext);

  if (!context) {
    throw Error('useCore can only be used inside Core');
  }

  return context;
};
